import React from "react";
import { EmptyState } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import RankChip from "../../../../ForBrands/ui/RankChip";
import DivergingBars from "../../../../ForBrands/ui/charts/DivergingBars";
import { ROLE } from "../../../../ForBrands/ui/charts/chartTokens";
import { signed1 } from "../../../../../utils/perfFormat";
import { NO_PATTERN, consistencyView, rankLede, resultLine, signedWhole } from "../teamPerformanceModel";
import { DetailLines, Figure, MedianText } from "./perfPieces";

// Consistency: Game-to-Game Net (BUILD_SPEC B7, Jayson's T7): the
// volatility (the standard deviation of per-game Net, ranked so steadier
// reads higher) and the blowout record (± the payload's threshold, never a
// fixed 15), then one bar per game from a midline, green above zero and
// red below. Each bar opens its game: a hover card on desktop (hover or
// keyboard focus), a readout above the chart after a tap on phones. With
// fewer than two boxed games there is no spread: σ reads "–" and a note
// stands in for the chart. A ranked volatility names its peer group (B5).

const LEGEND = [
  { key: "up", swatch: "bar", color: ROLE.better, label: "Net at or above 0" },
  { key: "down", swatch: "bar", color: ROLE.worse, label: "Net below 0" },
];

const TeamConsistencyCard = ({ payload, peer, collapse }) => {
  const view = consistencyView(payload);
  const sigmaChip = (view.sigma.chip || view.sigma.median) && (
    <>
      {view.sigma.chip && <RankChip percentile={view.sigma.chip.percentile} approximate={view.sigma.chip.approximate} band />}
      <MedianText text={view.sigma.median} />
    </>
  );
  const detail = (i) => {
    const item = view.items[i];
    if (!item) return null;
    return (
      <DetailLines
        title={`${item.date}${item.opponent ? ` vs ${item.opponent}` : ""}`}
        sub={resultLine(item.result, item.margin)}
        rows={[
          ["Net rating", signed1(item.value)],
          ["Margin", item.margin === null ? null : signedWhole(item.margin)],
        ]}
      />
    );
  };
  return (
    <CollapsibleCard title="Consistency: Game-to-Game Net" titleAs="h3" subtitle={view.ranked ? rankLede(peer) : null} {...collapse}>
      <div className="flex items-start justify-between gap-4">
        <Figure eyebrow="Volatility (σ of Net)" value={view.sigma.value} chip={sigmaChip} note="Lower is steadier" />
        <Figure eyebrow={view.blowoutLabel} value={view.blowouts} align="right" />
      </div>
      {view.chartNote ? (
        <EmptyState>{view.chartNote}</EmptyState>
      ) : (
        <>
          <DivergingBars
            items={view.items}
            renderDetail={detail}
            label="Games"
            ariaLabel={`Net rating by game over ${view.items.length} games, volatility ${view.sigma.value}`}
          />
          <LegendRow items={LEGEND} label="Consistency legend" />
        </>
      )}
      <InsightList insights={view.insights} variant="callout" emptyText={NO_PATTERN} />
    </CollapsibleCard>
  );
};

export default TeamConsistencyCard;
